import classNames from 'classnames'
import { memo } from 'react'
import Button from '../../../components/Button'
import { ReactComponent as Glow } from '../Glow.svg'

export default memo(function IllustrationStep({
    illustration: Illustration,
    title,
    description,
    step,
    totalSteps,
    onStepChange,
}) {
    return (
        <div className='flex flex-col w-full items-center'>
            <div style={{ width: '60%', aspectRatio: '505/215', overflow: 'visible', position: 'relative' }}>
                <Glow style={{ position: 'absolute', width: '100%', height: 'auto', aspectRatio: '781 / 547', pointerEvents: 'none' }} />
                <Illustration style={{ position: 'absolute', width: '100%', height: 'auto', aspectRatio: '505 / 300', pointerEvents: 'none' }} />
            </div>
            <div className='flex gap-2 items-center'>
                {Array.from({ length: totalSteps }, (_, index) => (
                    <div className='w-3 h-9 flex items-center justify-center cursor-pointer' key={index + 1}>
                        <div
                            className={classNames(
                                'bg-white rounded-full transition-[width,height,opacity] duration-300',
                                step === (index + 1) ? 'w-3 h-9' : 'w-2 h-6 opacity-50'
                            )}
                            onClick={() => onStepChange(index + 1)}
                        />
                    </div>
                ))}
            </div>
            <div className='text-white text-3xl font-bold mt-6'>
                {title}
            </div>
            <div className='text-neutral-500 mt-6'>
                {description}
            </div>
            <Button variant='primary' size='lg' className='w-48 mt-6' onClick={() => onStepChange(step + 1)}>
                {step === totalSteps ? 'Ready?' : 'Weiter'}
            </Button>
        </div>
    )
})

